import { FC, useMemo } from 'react';
import { Box, Flex, Switch } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useLocalStorageState } from '@netiva/classifieds-common';

import { landingPagePathnames as allowedPathnames, landingPageSelectionLocalStorageKey } from '@/lib/storage';

type LandingPageSelectionProps = {
  pathname: string;
};

const defaultPathname = allowedPathnames[0];

export const LandingPageSelection: FC<LandingPageSelectionProps> = ({ pathname }) => {
  const { t } = useTranslation();

  const isAllowedPathname = useMemo(() => allowedPathnames.includes(pathname), [pathname]);

  const [storage, setStorage] = useLocalStorageState<string>(landingPageSelectionLocalStorageKey, defaultPathname);
  const isChecked = isAllowedPathname && storage === pathname;

  const handleToggle = () => {
    if (!isChecked) {
      setStorage(pathname);
    } else {
      setStorage(defaultPathname);
    }
  };

  if (!isAllowedPathname) return null;

  return (
    <Flex justifyContent="end" alignItems="center" gap="4">
      <Box as="span" fontSize="sm">
        {t('landingPageSelection')}
      </Box>
      <Switch isChecked={isChecked} onChange={handleToggle} />
    </Flex>
  );
};
